module.exports = __webpack_public_path__ + "static/media/signUpMan.9d6b0d42.jpg";